import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentState } from '../../../store/state/content.state';

@Component({
    selector: 'u4-cpp-subscribe',
    templateUrl: './subscribe.component.html',
    styles: []
})
export class SubscribeComponent implements OnInit, OnDestroy {

    labels: {[key: string]: string};
    private destroy$: Subject<void> = new Subject<void>();

    constructor(private store: Store<ContentState>) {}

    ngOnInit() {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => this.labels = labels);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
